import { Input, Button }                                     from 'antd';
import axios                                                 from 'axios';
import L                                                     from 'leaflet';
import React, { useState, useEffect, useRef }                        from 'react';
import { MapContainer, WMSTileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { useNavigate, useParams }                            from "react-router-dom";
import FormTable                                             from '../../reuseableComponents/Form/Form';
import HeadingNDescription
                                                             from '../../reuseableComponents/headingNDescription/headingNDescription';
import "./AddProperty.scss";
import Loader                                                from '../../reuseableComponents/Loader/Loader';
import Notification                                          from '../../reuseableComponents/Notification';
import { getPropertyByIdApi }                                from '../details/apis/apis';
import { addPropertyApi, updateProperty }                    from './apis/apis';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const position = [39, 77];

const DraggableMarker = ({ position, onDragEnd }) => {
  const markerRef = useRef(null);

  return (
    <Marker
      position={position}
      draggable={true}
      eventHandlers={{
        dragend: () => {
          const marker = markerRef.current;
          if (marker != null) {
            const newPos = marker.getLatLng();
            onDragEnd([newPos.lat, newPos.lng]);
          }
        },
      }}
      ref={markerRef}
    >
      <Popup>
        You are here: {position[0].toFixed(4)}, {position[1].toFixed(4)}
      </Popup>
    </Marker>
  );
};

const MapMover = ({ position }) => {
  const map = useMap();
  map.setView(position, 13); // Move the map to the new position
  return null;
};

const locations = [
  { label: "Distrito Nacional", value: "Distrito Nacional" },
  { label: "Santo Domingo Este", value: "Santo Domingo Este" },
  { label: "Santo Domingo Norte", value: "Santo Domingo Norte" },
  { label: "Santo Domingo Oeste", value: "Santo Domingo Oeste" },
  { label: "Santiago", value: "Santiago" },
  { label: "Punta Cana", value: "Punta Cana" },
  { label: "San Cristóbal", value: "San Cristóbal" },
  { label: "La Vega", value: "La Vega" },
  { label: "Puerto Plata", value: "Puerto Plata" },
  { label: "San Pedro de Macorís", value: "San Pedro de Macorís" },
  { label: "Azua", value: "Azua" },
  { label: "Bahoruco", value: "Bahoruco" },
  { label: "Barahona", value: "Barahona" },
  { label: "Dajabón", value: "Dajabón" },
  { label: "Duarte", value: "Duarte" },
  { label: "El Seibo", value: "El Seibo" },
  { label: "Elías Piña", value: "Elías Piña" },
  { label: "Espaillat", value: "Espaillat" },
  { label: "Hato Mayor", value: "Hato Mayor" },
  { label: "Hermanas Mirabal", value: "Hermanas Mirabal" },
  { label: "Independencia", value: "Independencia" },
  { label: "La Altagracia", value: "La Altagracia" },
  { label: "La Romana", value: "La Romana" },
  { label: "María Trinidad Sánchez", value: "María Trinidad Sánchez" },
  { label: "Monseñor Nouel", value: "Monseñor Nouel" },
  { label: "Monte Plata", value: "Monte Plata" },
  { label: "Montecristi", value: "Montecristi" },
  { label: "Pedernales", value: "Pedernales" },
  { label: "Peravia", value: "Peravia" },
  { label: "Samaná", value: "Samaná" },
  { label: "San José de Ocoa", value: "San José de Ocoa" },
  { label: "San Juan", value: "San Juan" },
  { label: "Sánchez Ramírez", value: "Sánchez Ramírez" },
  { label: "Santiago Rodríguez", value: "Santiago Rodríguez" },
  { label: "Valverde", value: "Valverde" }
];
const AddProperty = () => {
  const { id } = useParams()
  let house = [
    {
      label: "Title",
      value: "title",
      type: "textArea",
      required: true,
      options: [],
      style: { gridColumn: "span 2" }
    },
    {
      label: "Description",
      value: "description",
      type: "textArea",
      required: true,
      options: [],
      style: { gridColumn: "span 2" }
    },
    {
      label: "City",
      value: "city",
      type: "select",
      options: locations,
      required: true
    },
  ]
  let contact = [
    {
      label: "Phone",
      value: "contact",
      type: "inp",
      required: true,
      options: []
    }]
  let price = [
    {
      label: "Price",
      value: "price",
      type: "inp",
      required: true,
      options: []
    },
    {
      label: "Photo",
      value: "photos",
      type: "upload",
      multiple: true,
      maxCount: 5,
      options: [],
      required: true
    },
    {
      label: "Type",
      value: "type",
      type: "select",
      options: [
        {
          label: "Home",
          value: "Home"
        },
        {
          label: "Apartment",
          value: 'Apartment'
        },
        {
          label: "Flat",
          value: 'Flat'
        }
      ],
      required:true
    },
    {
      label: "Purpose",
      value: "isForSale",
      type: "select",
      required:true,
      options: [
        {
          label: "Sale",
          value: true
        },
        {
          label: "Rent",
          value: false
        }
      ]
    }
  ]
  let address = [
    {
      label: "Street address",
      value: "address",
      type: "inp",
      options: []
    },
    {
      label: "Unit",
      value: "unit",
      type: "inp",
      options: []
    },
    {
      label: "Province",
      value: "province",
      type: "inp",
      options: []
    },
    {
      label: "Postal Code",
      value: "postalCode",
      type: "inp",
      options: []
    }
  ]

  let homeFacts = [
    {
      label: "Beds",
      value: "beds",
      type: "inp",
      options: []
    },
    {
      label: "Parking Lots",
      value: "parkingLots",
      type: "inp",
      options: []
    },
    {
      label: "Lot Size",
      value: "lotSize",
      type: "inp",
      options: []
    },
    {
      label: "Build Size",
      value: "buildSize",
      type: "inp",
      options: []
    },
    {
      label: "1/2 Baths",
      value: "fullBaths",
      type: "inp",
      options: []
    },
    {
      label: "Balconies",
      value: "balconies",
      type: "inp",
      options: []
    },
    {
      label: "Year Build",
      value: "yearBuild",
      type: "inp",
      options: []
    }
  ]
  let rooms = [
    {
      label: "Living Room",
      value: "livingRoom",
      type: "checkBox",
      options: []
    },
    {
      label: "Dining Room",
      value: "diningRoom",
      type: "checkBox",
      options: []
    },
    {
      label: "Laundary room",
      value: "laundryRoom",
      type: "checkBox",
      options: []
    },
    {
      label: "Walk-in closet",
      value: "walkInCloset",
      type: "checkBox",
      options: []
    },
    {
      label: "Mud room",
      value: "mudRoom",
      type: "checkBox",
      options: []
    },
    {
      label: "Recreation room",
      value: "recreationRoom",
      type: "checkBox",
      options: []
    },
  ]

  let amenities = [
    {
      label: "Pool",
      value: "pool",
      type: "checkBox",
      options: []
    },
    {
      label: "Jacuzzi",
      value: "jacozzi",
      type: "checkBox",
      options: []
    },
    {
      label: "Elevator",
      value: "elevator",
      type: "checkBox",
      options: []
    },
    {
      label: "Gym",
      value: "gym",
      type: "checkBox",
      options: []
    },
    {
      label: "Kids area",
      value: "kidsArea",
      type: "checkBox",
      options: []
    },
    {
      label: "Spa",
      value: "spa",
      type: "checkBox",
      options: []
    },
    {
      label: "Cinema",
      value: "cinema",
      type: "checkBox",
      options: []
    },
    {
      label: "Event room",
      value: "eventRoom",
      type: "checkBox",
      options: []
    },
    {
      label: "Laundary",
      value: "laundry",
      type: "checkBox",
      options: []
    },
    {
      label: "BBQ",
      value: "bbq",
      type: "checkBox",
      options: []
    },
  ]

  let allData = [
    ...house,
    ...contact,
    ...price,
    ...address,
    ...homeFacts,
    ...rooms,
    ...amenities
  ]

  const [mapPosition, setMapPosition] = useState(position);
  const [input, setInput] = useState('');
  const [state, setState] = useState({
    formData: allData,
    loader: false
  })

  const navigation = useNavigate()
  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${ input }`
      );

      if (response.data.length > 0) {
        const location = response.data[0]; // Get first result
        const newLatLng = [parseFloat(location.lat), parseFloat(location.lon)];
        setMapPosition(newLatLng); // Update map position
      }
      else {
        alert('Location not found');
      }
    }
    catch (error) {
      console.error('Error fetching location:', error);
    }
  };

  const addProperty = async (values) => {
    let data = mapPosition.length > 0 ? {
      ...values,
      latitude: mapPosition[0],
      longitude: mapPosition[1]
    } : values
    data = {
      ...data,
      photos: !!data?.photos?.length > 0 ? data?.photos.map(item => !!item?.url ? item.url : item?.response?.data[0]) : null
    }

    try {
      if (id) {
        let result = await updateProperty(id, data)
        if (result?.data?.success) {
          Notification('success', "Property Updated Successfully");
          navigation("/myProperties")
        }
        else {
          Notification('error', "Error", "Error while updating property");
        }
      }
      else {
        let result = await addPropertyApi(data)
        if (result?.data?.success) {
          Notification('success', "Property Added Successfully");
          navigation("/myProperties")
        }
        else {
          Notification('error', "Error", "Error");
        }
      }
    }
    catch (err) {
      Notification('error', "Error", err?.response?.data?.data?.message === "Data truncated for column 'price' at row 1" ? "Price shoud be number only" : err?.response?.data?.data?.message);
    }
  };

  const getProperty = async () => {
    setState({
      ...state,
      loader: true
    });

    const response = await getPropertyByIdApi(id);

    if (response?.data?.data) {
      setMapPosition([response.data.data?.latitude, response.data.data?.longitude])
      let newData = Object.keys(allData).map(key => ({
        ...allData[key],
        defaultValue: response.data.data.hasOwnProperty(allData[key].value)
          ? response.data.data[allData[key].value]
          : null
      }));

      const photos = Array.isArray(response.data.data.photos)
        ? response.data.data.photos.map((item, idx) => ({
          url: item,
          uid: `${idx}`,
          name: `file${idx}.jpg`,
          status: "done"
        }))
        : null;

      newData=newData.map(item=> item?.label ==="Photo" ?  {
        ...item,
        defaultValue: photos
      } : item)

      setState({
        ...state,
        formData: newData,
        loader: false
      });
    } else {
      console.log("error while fetching property");
      setState({
        ...state,
        loader: false
      });
    }
  };

  useEffect(() => {
    !!id && getProperty()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !!state.loader ? <Loader/> : <div className={ "addPropertyContainer" }>
    <HeadingNDescription
      style={ {
        marginTop: window.innerWidth > 790 ? "5%" : "10%"
      } }
      heading={ "Let’s add your property" }
      description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }/>
    <div className={ "inputOfMap" }>
      <h5>Enter Location</h5>
      <div style={ {
        display: "flex",
        gap: 10,
        alignItems: "center",
        marginTop: 10
      } }>
        <Input
          type="text"
          value={ input }
          onChange={ (e) => setInput(e.target.value) }
          placeholder={ "Enter here" }/>
        <Button type={ "primary" } onClick={ handleSearch } onKeyDown={handleSearch}>
          Search
        </Button>
      </div>
    </div>
    <MapContainer center={mapPosition} zoom={13} scrollWheelZoom={true}
                  style={{ height: "60vh", width: "100%", marginTop: 40 }}>

      <WMSTileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <DraggableMarker position={mapPosition} onDragEnd={setMapPosition} />

      <MapMover position={mapPosition} />

    </MapContainer>
    <FormTable data={ state.formData } customStyle={
      {
        display: window.innerWidth > 790 ? "grid" : "",
        gridTemplateColumns: window.innerWidth > 790 ? "22% 22% 22% 22%" : "100%",
        justifyContent: "space-between",
        gap: 20,
        width: "100%",
        marginTop: "3%"
      } } buttonLabel={ !!id ? "Update" : "Save" }
               heading={ "Address" }
               mainWidth={ "90%" }
               showSaveBtn={ true }
               saveFunc={ addProperty }
               multipleFiles={ true }
               initialValues={ state.formData }
    />
  </div>
}

export default AddProperty